const style = {
  container: {
    textAlign: 'left',
    marginLeft: '10vw',
    marginRight: '10vw',
    padding: '5vh'
  },
  input: {
    flex: 1,
    whiteSpace: 'nowrap',
    marginRight: 5,
    minWidth: 200,
  },
  lastInput: {
    flex: 1,
    whiteSpace: 'nowrap',
    marginRight: 5,
    minWidth: 150,
    width: 150,
        // overflow: 'hidden'
  },
  inputWrap: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    position: 'relative'
  },
  inputNoWrap: {
    display: 'flex',
    flex: 1,
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  inputVerticalWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    flexWrap: 'nowrap',
    alignContents: 'center',
    padding: 10
  },
  datePickerContainer: {
    display: 'flex',
    flex: 1,
    width: 175
  },
  datePickerText: {
    flex: 1,
    marginRight: 5,
    minWidth: 175,
  },
  errorText: {
    color: 'red',
    fontSize: 14
  },
  tableIcon: {
    color: 'gray',
    width: 20,
    height: 20,
    padding: 0,
    marginRight: 8,
  },
  tableIcon2: {
    color: 'gray',
    width: 20,
    height: 20,
    padding: 0,
    marginRight: 8,
    position: 'absolute',
    margin: 'auto',
    top: 0,
    bottom: 0,
    right: -15,
        // backgroundColor: 'white'
  },
  tableSelectFieldSmall: {
    width: 48,
        // backgroundColor: 'blue',
  },
  tableSelectField: {
    fontSize: 12,
    width: '100%',
    verticalAlign: 'bottom',
  },
  tableSelectFieldLable: {
    paddingLeft: 0, paddingRight: 28
  },
  tableTextField: {
    width: '100%',
    fontSize: 12,
  },
  noUnderline: {
    display:'none',
  }
}

export default style



// WEBPACK FOOTER //
// ./src/styles/commonStyle.js